import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-body" }
const _hoisted_2 = { class: "loading-message" }

import Tools from '@/ts/Tools';
import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingComponent',
  setup(__props, { expose: __expose }) {

const show = ref(false);
const loadingMessage = ref('加载中...');
function Show() {
    show.value = true;
}
function Hide() {
    show.value = false;
}

function SetLoadingMessage(message: string) {
    if (Tools.IsNotNull(message))
        loadingMessage.value = message;
}

__expose({
    Show,
    Hide,
    SetLoadingMessage
})

return (_ctx: any,_cache: any) => {
  const _component_VanLoading = _resolveComponent("VanLoading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanLoading, { vertical: "" }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(loadingMessage.value), 1)
      ]),
      _: 1
    })
  ], 512)), [
    [_vShow, show.value]
  ])
}
}

})